// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__LAyOd","footer":"Form_footer__2G_fK"};